import styled from "styled-components";
export const ModalWrapper = styled.div`
  color: red;
  background-color: ${({ theme }) => theme.body};
  .modal-body {
    height: auto;
  }
`;
